import React, {memo, useEffect} from "../../../../__snowpack__/pkg/react.js";
import {Form, Input, Modal} from "../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {useIntlTyped} from "../../../lib/useIntlTyped.js";
import {useWrapSync} from "../../../lib/useWrapSync.js";
import {localeMessage} from "../../../views/product-local-publish/i18n.js";
const MassEditNameModal = memo((props) => {
  const {modalProps = {}, visible} = props;
  const {formatMessage} = useIntlTyped(localeMessage);
  const [form] = Form.useForm();
  const {wrapSync: wrapSubmitHandler, loading: submitHandlerLoading} = useWrapSync();
  const submitHandler = wrapSubmitHandler(async () => {
    try {
      const values = await form.validateFields();
      props.onOk && await props.onOk(values);
    } catch (error) {
      return;
    }
  });
  useEffect(() => {
    if (props.visible) {
      form.resetFields();
    }
  }, [props.visible]);
  return /* @__PURE__ */ React.createElement(ModalWrapper, {
    visible,
    okText: formatMessage({id: "applyToAllProducts"}),
    title: formatMessage({id: "editDescription"}),
    confirmLoading: submitHandlerLoading,
    onOk: () => {
      submitHandler();
    },
    onCancel: () => {
      props.onCancel && props.onCancel();
    },
    ...modalProps
  }, /* @__PURE__ */ React.createElement(Form, {
    layout: "vertical",
    form
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "addBefore",
    label: formatMessage({id: "addBeforeName"})
  }, /* @__PURE__ */ React.createElement(Input, {
    placeholder: formatMessage({id: "pleaseEnter"})
  })), /* @__PURE__ */ React.createElement(Form.Item, {
    name: "addAfter",
    label: formatMessage({id: "addAfterName"})
  }, /* @__PURE__ */ React.createElement(Input, {
    placeholder: formatMessage({id: "pleaseEnter"})
  })), /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({id: "replaceWith"})
  }, /* @__PURE__ */ React.createElement(Input.Group, {
    className: "custom-input-group custom-input-group-handler",
    compact: true
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "replaceFrom",
    noStyle: true
  }, /* @__PURE__ */ React.createElement(Input, null)), /* @__PURE__ */ React.createElement(Form.Item, {
    noStyle: true
  }, /* @__PURE__ */ React.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #ADBACC",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "nowrap",
      padding: "0 10px"
    }
  }, formatMessage({id: "replaceWith"}))), /* @__PURE__ */ React.createElement(Form.Item, {
    name: "replaceTo",
    noStyle: true
  }, /* @__PURE__ */ React.createElement(Input, null))))));
});
const ModalWrapper = styled(Modal)`
  .title {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
    font-family: SFProText-Medium, SFProText;
    color: #212b36;
    line-height: 22px;
  }
  .ant-modal-body {
    margin-bottom: -16px;
  }
  .ant-table-tbody {
    vertical-align: top;
  }
  .ant-form-item {
    margin-bottom: 16px;
  }
  .custom-input-group {
    display: flex;
    .ant-input-number {
      flex: 1;
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .custom-input-group-handler {
    .ant-input-number-handler-wrap {
      display: block;
      opacity: 1;
    }
  }
`;
export default MassEditNameModal;
